module.exports = __webpack_public_path__ + "img/recommen-img2.a9c6cd1e.png";